import { ProductGridSkeletonProps } from '../../types/components/shared/ProductGridSkeleton';

const GRID_PLACEHOLDERS_COUNT = 8;
const gridItemsRange = Array.from({ length: GRID_PLACEHOLDERS_COUNT }, (_, i) => 0 + i);

const ProductGridSkeleton: React.FC<ProductGridSkeletonProps> = ({
  visible,
}) => {
  if (!visible) return;
  return (
    <div className="w-full" data-testid="productsCollectionsContainer">
      <div className="responsive-product-grid md:min-w-[400px] gap-x-4 gap-y-6">
      {gridItemsRange.map(index => (
          <div key={index}>
            <div className="w-[380px] h-[214px] rounded-[5px] bg-shimmer bg-[length:200%_100%] animate-shimmer"/>
            <div className="mt-1 h-[21px] rounded-[5px] w-[33%] bg-shimmer bg-[length:200%_100%] animate-shimmer" />
          </div>
        ))}
      </div>
    </div>
  )
};

export default ProductGridSkeleton;
